import { Row, Col, Button } from 'react-bootstrap';
import { TextButton } from 'Components/Button';
import FeaturedCard from './FeaturedCard';
import { ICONS } from "Utils/icons";
import NewsEventCard from '../Home/NewsEventCard';
import { NEWS_AND_UPDATES_DATA } from './NewsAndUpdatesData';
import { useState } from 'react';
import { MULTI_FEATURED_CARD_DATA, SINGLE_FEATURED_CARD_DATA } from './FeaturedCardData';

const { LeftPageHeader } = require("Components/Public/PageHeader/PageHeader");

const NewsAndUpdates = () => {

  const [newsAndUpdatesList, setNewsAndUpdatesList] = useState(NEWS_AND_UPDATES_DATA);
  // activeTypeKey: "All", "EVENT", "ANNOUNCEMENT"
  const [activeTypeKey, setActiveTypeKey] = useState("All");
  // activeSortKey: "newest", "oldest"
  const [activeSortKey, setActiveSortKey] = useState("newest")

  // set activeTypeKey & sort newsAndUpdatesList by activeTypeKey
  const handleActiveTypeKey = (typeKey) => {
    setActiveTypeKey(typeKey);

    if (typeKey === 'All') {
      if (activeSortKey === "newest") {
        setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA.sort((a, b) => a.id - b.id));
      } else {
        setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA.sort((a, b) => b.id - a.id));
      }
      return;
    }

    if (activeSortKey === "newest") {
      setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA
        .filter(item => item.type === typeKey)
        .sort((a, b) => a.id - b.id)
      );
    } else {
      setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA
        .filter(item => item.type === typeKey)
        .sort((a, b) => b.id - a.id)
      );
    }
  }

  // set activeSortKey & sort newsAndUpdatesList by activeSortKey
  const handleActiveSortKey = (sortKey) => {
    setActiveSortKey(sortKey);

    if (activeTypeKey === 'All') {
      if (sortKey === "newest") {
        setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA.sort((a, b) => a.id - b.id));
      } else {
        setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA.sort((a, b) => b.id - a.id));
      }
      return;
    }

    if (sortKey === "newest") {
      setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA
        .filter(item => item.type === activeTypeKey)
        .sort((a, b) => a.id - b.id)
      );
    } else {
      setNewsAndUpdatesList(NEWS_AND_UPDATES_DATA
        .filter(item => item.type === activeTypeKey)
        .sort((a, b) => b.id - a.id)
      );
    }
  }

  return (
    <>
      <LeftPageHeader
        subTitle=""
        title="News & Updates"
        intro="New updates and improvements to PSOPPC & the Network of Patient Safety Databases (NPSD)"
        rightContent={
          <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content ms-auto me-auto h-100 w-50 justify-content-center mt-2 mb-2">
            <TextButton
              variant={"outline-clear"}
              //onClick={handleLogin}
              content={"Subscribe"}
              className="button-width"
            />
          </div>
        }
      >
      </LeftPageHeader>
      {/* Featured Title */}
      <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0 mt-5">
        {/* place holder of 2 columns to be left aligned with the header */}
        <Col xxl={2}></Col>
        <Col className='d-none d-lg-block text-start news-update-subtitle mx-lg-4 mx-xxl-0'>
          <h2>Featured</h2>
        </Col>
        <Col xs={11} className='d-block d-lg-none text-start news-update-subtitle'>
          <h2>Featured</h2>
        </Col>
      </Row>
      {/* Featured Cards*/}
      {/* Featured Card single */}
      {SINGLE_FEATURED_CARD_DATA.map((item, index) => (
        <Row className="d-flex justify-content-center m-0 p-0 g-0 mt-3 featured-content">
          <Col xxl={2}></Col>
          {/* show > lg */}
          <Col className='d-none d-lg-block mb-4 ms-lg-4 me-lg-4 ms-xxl-0 me-xxl-0'>
            <FeaturedCard
              isMultiple={item.isMultiple}
              type={item.type}
              icon={item.icon}
              postedDate={item.postedDate}
              eventEndDate={item.eventEndDate}
              registrationEndDate={item.registrationEndDate}
              registrationCloseInfo={item.registrationCloseInfo}
              isRegistration={item.isRegistration}
              title={item.title}
              desc={item.desc}
              additionalInfo={item.additionalInfo}
              additionalInfoMobile={item.additionalInfoMobile}
            ></FeaturedCard>
          </Col>
          <Col xxl={2}></Col>
          {/* show < lg */}
          <Col xs={11} className='d-block d-lg-none mb-4 ms-lg-4 me-lg-4 ms-xxl-0 me-xxl-0'>
            <FeaturedCard
              isMultiple={item.isMultiple}
              type={item.type}
              icon={item.icon}
              postedDate={item.postedDate}
              eventEndDate={item.eventEndDate}
              registrationEndDate={item.registrationEndDate}
              registrationCloseInfo={item.registrationCloseInfo}
              isRegistration={item.isRegistration}
              title={item.title}
              desc={item.desc}
              additionalInfo={item.additionalInfo}
              additionalInfoMobile={item.additionalInfoMobile}
            ></FeaturedCard>
          </Col>
        </Row >
      ))}
      {/* Featured Cards multiple */}
      {MULTI_FEATURED_CARD_DATA.map((item, key) => (

        < Row className="d-flex justify-content-center m-0 p-0 g-0 mt-3 featured-content" >
          <Col xxl={2}></Col>
          {/* show > lg */}
          <Col className='d-none d-lg-block text-start me-lg-5 ms-lg-4 ms-xxl-0'>
            <FeaturedCard
              isMultiple={item[0].isMultiple}
              type={item[0].type}
              icon={item[0].icon}
              postedDate={item[0].postedDate}
              eventEndDate={item[0].eventEndDate}
              registrationEndDate={item[0].registrationEndDate}
              registrationCloseInfo={item[0].registrationCloseInfo}
              isRegistration={item[0].isRegistration}
              title={item[0].title}
              desc={item[0].desc}
              additionalInfo={item[0].additionalInfo}
            ></FeaturedCard>
          </Col>
          {/* show > lg */}
          <Col className='d-none d-lg-block text-start me-lg-4 me-xxl-0'>
            <FeaturedCard
              isMultiple={item[1].isMultiple}
              type={item[1].type}
              icon={item[1].icon}
              postedDate={item[1].postedDate}
              eventEndDate={item[1].eventEndDate}
              registrationEndDate={item[1].registrationEndDate}
              registrationCloseInfo={item[1].registrationCloseInfo}
              isRegistration={item[1].isRegistration}
              title={item[1].title}
              desc={item[1].desc}
              additionalInfo={item[1].additionalInfo}
            ></FeaturedCard>
          </Col>
          <Col xxl={2}></Col>
          {/* show < lg */}
          <Col xs={11} className='d-block d-lg-none text-start mb-5'>
            <FeaturedCard
              isMultiple={item[0].isMultiple}
              type={item[0].type}
              icon={item[0].icon}
              postedDate={item[0].postedDate}
              eventEndDate={item[0].eventEndDate}
              registrationEndDate={item[0].registrationEndDate}
              registrationCloseInfo={item[0].registrationCloseInfo}
              isRegistration={item[0].isRegistration}
              title={item[0].title}
              desc={item[0].desc}
              additionalInfo={item[0].additionalInfo}
              additionalInfoMobile={item[0].additionalInfoMobile}
            ></FeaturedCard>
          </Col>
          {/* show < lg */}
          <Col xs={11} className='d-block d-lg-none text-start'>
            <FeaturedCard
              isMultiple={item[1].isMultiple}
              type={item[1].type}
              icon={item[1].icon}
              postedDate={item[1].postedDate}
              eventEndDate={item[1].eventEndDate}
              registrationEndDate={item[1].registrationEndDate}
              registrationCloseInfo={item[1].registrationCloseInfo}
              isRegistration={item[1].isRegistration}
              title={item[1].title}
              desc={item[1].desc}
              additionalInfo={item[1].additionalInfo}
              additionalInfoMobile={item[1].additionalInfoMobile}
            ></FeaturedCard>
          </Col>
        </Row >
      ))}
      {/* All Updates tabs and filters*/}
      < Row className="d-flex justify-content-center w-100 m-0 p-0 g-0 mt-5" >
        {/* place holder of 2 columns to be left aligned with the header */}
        < Col xxl={2} ></Col >
        <Col className='d-none d-lg-block text-start news-update-subtitle mx-lg-4 mx-xxl-0'>
          <h2>All Updates</h2>
        </Col>
        <Col xs={11} className='d-block d-lg-none text-start news-update-subtitle'>
          <h2>All Updates</h2>
        </Col>
      </Row >
      <Row className="d-flex justify-content-center  w-100 m-0 p-0 g-0 mt-2">
        {/* place holder of 2 columns to be left aligned with the header */}
        <Col xxl={2}></Col>
        {/* show > lg */}
        <Col className='text-start d-none d-lg-block mx-lg-4 mx-xxl-0'>
          <div className='d-flex justify-content-between'>
            <div className='d-inline all-updates-tabs'>
              <Button
                className='all-updates-tab me-3'
                active={activeTypeKey === "All"}
                onClick={() => handleActiveTypeKey("All")}
              >
                All
              </Button>
              <Button
                className='all-updates-tab me-3'
                active={activeTypeKey === "EVENT"}
                onClick={() => handleActiveTypeKey("EVENT")}
              >
                Events
              </Button>
              <Button
                className='all-updates-tab'
                active={activeTypeKey === "ANNOUNCEMENT"}
                onClick={() => handleActiveTypeKey("ANNOUNCEMENT")}
              >
                Announcements
              </Button>
            </div>
            <div className='d-inline all-updates-filters'>
              <span className='text me-3'>Sort by:</span>
              <span className='filters-background'>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "newest"}
                  onClick={() => handleActiveSortKey("newest")}
                >
                  Newest First
                </Button>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "oldest"}
                  onClick={() => handleActiveSortKey("oldest")}
                >
                  Oldest First
                </Button>
              </span>
            </div>
          </div>
        </Col>
        <Col xxl={2}></Col>
        {/* show on md and lg */}
        <Col xs={11} className='text-start d-none d-md-block d-lg-none'>
          <div className='d-flex justify-content-between'>
            <div className='d-inline all-updates-tabs'>
              <Button
                className='all-updates-tab me-3'
                active={activeTypeKey === "All"}
                onClick={() => handleActiveTypeKey("All")}
              >
                All
              </Button>
              <Button
                className='all-updates-tab me-3'
                active={activeTypeKey === "EVENT"}
                onClick={() => handleActiveTypeKey("EVENT")}
              >
                Events
              </Button>
              <Button
                className='all-updates-tab'
                active={activeTypeKey === "ANNOUNCEMENT"}
                onClick={() => handleActiveTypeKey("ANNOUNCEMENT")}
              >
                Announcements
              </Button>
            </div>
            <div className='d-inline all-updates-filters'>
              <span className='text me-3'>Sort by:</span>
              <span className='filters-background'>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "newest"}
                  onClick={() => handleActiveSortKey("newest")}
                >
                  Newest First
                </Button>
                <Button
                  className='filter me-2'
                  active={activeSortKey === "oldest"}
                  onClick={() => handleActiveSortKey("oldest")}
                >
                  Oldest First
                </Button>
              </span>
            </div>
          </div>
        </Col>
        {/* show on xs and sm */}
        <Col xs={11} className='text-start d-block d-md-none'>
          <div className='d-inline all-updates-tabs'>
            <Button
              className='all-updates-tab me-3'
              active={activeTypeKey === "All"}
              onClick={() => handleActiveTypeKey("All")}
            >
              All
            </Button>
            <Button
              className='all-updates-tab me-3'
              active={activeTypeKey === "EVENT"}
              onClick={() => handleActiveTypeKey("EVENT")}
            >
              Events
            </Button>
            <Button
              className='all-updates-tab'
              active={activeTypeKey === "ANNOUNCEMENT"}
              onClick={() => handleActiveTypeKey("ANNOUNCEMENT")}
            >
              Announcements
            </Button>
          </div>
        </Col>
        <Col xs={11} className='text-start d-block d-md-none mt-3'>
          <div className='d-inline all-updates-filters'>
            <span className='text me-3'>Sort by:</span>
            <span className='filters-background'>
              <Button
                className='filter me-2'
                active={activeSortKey === "newest"}
                onClick={() => handleActiveSortKey("newest")}
              >
                Newest First
              </Button>
              <Button
                className='filter me-2'
                active={activeSortKey === "oldest"}
                onClick={() => handleActiveSortKey("oldest")}
              >
                Oldest First
              </Button>
            </span>
          </div>
        </Col>
      </Row>
      {/* All Updates Card list */}
      <Row className='mx-0 p-0 all-updates'>
        {
          newsAndUpdatesList.map((item, index) => (
            <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0 mt-3">
              {/* place holder of 2 columns to be left aligned with the header */}
              <Col xxl={2}></Col>
              {/* show > lg */}
              <Col className='d-none d-lg-block text-start news-updates-card-section mx-lg-4 mx-xxl-0'>
                <NewsEventCard
                  key={item.type + index}
                  type={item.type}
                  postedDate={item.postedDate}
                  eventDate={item.eventDate}
                  eventTime={item.eventTime}
                  registrationEndDate={item.registrationEndDate}
                  registrationCloseInfo={item.registrationCloseInfo}
                  isRegistration={item.isRegistration}
                  title={item.title}
                  description={item.description}
                  icon={item.icon}
                  docGroupId={item.docGroupId}
                >
                </NewsEventCard>
              </Col>
              <Col xxl={2}></Col>
              {/* show < lg */}
              <Col xs={11} className='d-block d-lg-none text-start news-updates-card-section'>
                <NewsEventCard
                  key={item.type + index}
                  type={item.type}
                  postedDate={item.postedDate}
                  eventDate={item.eventDate}
                  eventTime={item.eventTime}
                  registrationEndDate={item.registrationEndDate}
                  registrationCloseInfo={item.registrationCloseInfo}
                  isRegistration={item.isRegistration}
                  title={item.title}
                  description={item.description}
                  icon={item.icon}
                  //additionalInfo={item.additionalInfo}
                  docGroupId={item.docGroupId}
                //additionalInfoMobile={item.additionalInfoMobile}
                >
                </NewsEventCard>
              </Col>
            </Row>
          ))
        }
        {
          newsAndUpdatesList.length === 0 ?
            <Row className="d-flex justify-content-center w-100 m-0 p-0 g-0 my-3">
              <Col>
                There is no {activeTypeKey}
              </Col>
            </Row>
            : null
        }
      </Row>
    </>
  )
}

export default NewsAndUpdates;